<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> FAQ知识库 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-select v-model="listQuery.game_id" placeholder="游戏名称" filterable style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in gameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <el-select v-model="listQuery.type_id" placeholder="问题类型" filterable style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in typeData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <el-input v-model="listQuery.problem" placeholder="问题详情" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.answer" placeholder="答案详情" style="width: 200px; margin-right: 10px"></el-input>
          <el-date-picker
            v-model="listQuery.created_at"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['24:00:00']"
            style="margin-right: 10px"
          >
          </el-date-picker>
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
          <el-button class="filter-item" type="success" @click="handleCreate">添加</el-button>
          <el-button class="filter-item" type="warning" @click="handleResetSearch">重置</el-button>
          <a class="download" :href="downloadFileUrl" download="" title="下载"><el-button type="primary">下载模板</el-button></a>

          <el-upload class="upload-demo" :action="serverFileUrl" :headers="header" :on-success="importFaq">
            <el-button type="warning" style="margin-top: -2px">点击上传</el-button>
          </el-upload>
        </div>

        <el-table border v-loading="listLoading" min-height="200" max-height="1000" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="问题ID" align="center" />
          <el-table-column prop="game_name" label="游戏名" align="center" />
          <el-table-column prop="type_name" label="问题类型" align="center" />
          <el-table-column prop="problem" label="问题详情" align="center" />
          <el-table-column prop="answer" label="答案详情" align="center" />
          <el-table-column prop="admin_name" label="新增人" align="center" />
          <el-table-column prop="created_at" label="新增时间" align="center" />
          <el-table-column label="操作" align="center" width="400" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button type="warning" style="margin-right: 10px" size="mini" @click="handleDetail(scope.row)">查看详情</el-button>
              <el-button type="primary" style="margin-right: 10px" size="mini" icon="el-icon-edit" @click="handleUpdate(scope.row)">修改</el-button>
              <el-popover placement="top" width="100" style="margin-right: 10px" v-model="scope.row.deleteVisible">
                <p>确定删除吗?</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                  <el-button type="primary" size="mini" icon="el-icon-delete" @click="handleDelete(scope.row)">确定</el-button>
                </div>
                <el-button slot="reference" size="mini" type="danger">删除</el-button>
              </el-popover>
              <el-button type="info" style="margin-right: 10px" size="mini" @click="handleLogData(scope.row)">历史记录</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- Table -->
        <el-dialog title="历史记录" center :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="created_at" label="时间" width="150"></el-table-column>
            <el-table-column property="admin_name" label="操作人" width="200"></el-table-column>
            <el-table-column property="content" label="修改内容"></el-table-column>
          </el-table>
        </el-dialog>
        <!-- Table -->

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleList" />
        <el-dialog :title="popupTitle" center width="60%" :visible.sync="dialogFormVisible" @closed="handleResetDetailForm" :close-on-click-modal="addControl">
          <el-form :model="formData" style="margin-left: 50px">
            <el-form-item label="ID" :label-width="formLabelWidth" v-if="formData.id != ''">
              <el-col :span="8">
                <el-input v-model="formData.id" :disabled="idDisabled"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="游戏" :label-width="formLabelWidth" v-if="formData.id == ''">
              <el-col :span="8">
                <el-select v-model="formData.game_id" filterable placeholder="请选择" :reserve-keyword="true">
                  <el-option v-for="item in gameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="游戏" :label-width="formLabelWidth" v-if="formData.id != ''">
              <el-col :span="8">
                <el-select v-model="formData.game_id" filterable placeholder="请选择" :reserve-keyword="true" :disabled="idDisabled">
                  <el-option v-for="item in gameData" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="类型" :label-width="formLabelWidth" v-if="formData.id == ''">
              <el-col :span="8">
                <el-select v-model="formData.type_id" filterable placeholder="请选择" :reserve-keyword="true">
                  <el-option v-for="item in typeData" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>
            <el-form-item label="类型" :label-width="formLabelWidth" v-if="formData.id != ''">
              <el-col :span="8">
                <el-select v-model="formData.type_id" filterable placeholder="请选择" :reserve-keyword="true" :disabled="idDisabled">
                  <el-option v-for="item in typeData" :key="item.index" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="新建人" :label-width="formLabelWidth" v-if="formData.id != ''">
              <el-col :span="8">
                <el-input type="text" v-model="formData.admin_name" :rows="8" :disabled="idDisabled"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="问题详情" :label-width="formLabelWidth">
              <el-col :span="18">
                <!-- 图片上传组件辅助-->
                <el-upload
                  ref="richTextUpload"
                  v-show="false"
                  class="avatar-uploader"
                  drag
                  multiple
                  :action="serverUrl"
                  name="img"
                  :headers="header"
                  :show-file-list="false"
                  :on-change="richTextUploadChange"
                  :on-success="uploadSuccess"
                  :on-error="uploadError"
                  :on-remove="richTextUploadRemove"
                  :before-upload="beforeUpload"
                >
                </el-upload>
                <div v-if="richTextFailedItems.length" class="rich-text-upload-errors">
                  <span>上传失败：</span>
                  <el-tag v-for="item in richTextFailedItems" :key="item.uid" closable type="danger" @close="removeRichTextFailure(item)">{{ item.name }}</el-tag>
                </div>
                <quill-editor v-model="formData.problem" ref="questionEditor" :options="questionEditorOption" @change="onEditorChange($event)"> </quill-editor>
              </el-col>
            </el-form-item>

            <el-form-item label="答案详情" :label-width="formLabelWidth">
              <el-col :span="18">
                <quill-editor v-model="formData.answer" ref="answerEditor" :options="answerEditorOption" @change="onEditorChange($event)"> </quill-editor>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeForm">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore" v-if="detail == 0">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { handleListApi, handleCreateStoreApi, handleDeleteApi, handleLogDataApi, handleGetSelectApi, getSingleFaqApi } from '@/api/faq.js';
import Pagination from '@/components/pagination/index';
import { getToken } from '@/utils/localStorage.js';
import BASE_API from '@/config';
import { imageUploadMixin } from '@/utils/imageUpload.js';

const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'], // toggled buttons
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
  [{ direction: 'rtl' }], // text direction
  [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ['link', 'image'],
  ['clean'],
];
export default {
  mixins: [imageUploadMixin],
  components: { Pagination },
  name: 'faqIndex',
  data() {
    return {
      gameData: [],
      typeData: [],
      gridData: [],
      detail: 0,
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 10,
      },
      popupTitle: '',
      // 添加数据的缓存。
      addData: {},
      addCheck: 0,

      //表格
      dialogTableVisible: false,
      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      formData: {
        problem: '',
        answer: '',
        game_id: '',
        type_id: '',
      },
      formLabelWidth: '120px',
      quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
      content: null,
      header: {
        // token: sessionStorage.token
        Authorization: 'Bearer ' + getToken(),
      }, // 有的图片服务器要求请求头需要有toke
      questionEditorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: (value) => {
                if (value) {
                  this.openRichTextImagePicker('question');
                } else {
                  this.quill.format('image', false);
                }
              },
            },
          },
        },
      },
      answerEditorOption: {
        placeholder: '',
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions,
            handlers: {
              image: (value) => {
                if (value) {
                  this.openRichTextImagePicker('answer');
                } else {
                  this.quill.format('image', false);
                }
              },
            },
          },
        },
      },
      richTextUploadContext: null,
      richTextUploadBatch: 0,
      richTextUploadSequence: 0,
      richTextUploadItems: [],
      // serverUrl: 'http://worksn.hzwxbz2.cn/api/v1/admin/work_upload',  // 这里写你要上传的图片服务器地址
      // serverFileUrl: 'http://worksn.hzwxbz2.cn/api/v1/import_faq',  // 这里写你要上传的图片服务器地址
      // downloadFileUrl: 'http://worksn.hzwxbz2.cn/api/v1/faq_download',  //下载模板地址
      serverUrl: BASE_API + 'admin/work_upload', // 这里写你要上传的图片服务器地址
      serverFileUrl: BASE_API + 'import_faq', // 这里写你要上传的图片服务器地址
      downloadFileUrl: BASE_API + 'faq_download', //下载模板地址
    };
  },
  created() {
    this.handleList(this.listQuery);
    this.handleGetSelect();
  },
  computed: {
    richTextFailedItems() {
      return this.richTextUploadItems.filter((item) => item.status === 'failed');
    },
    addControl() {
      let item = true;
      if (this.popupTitle == '添加') {
        item = false;
      }
      return item;
    },
  },
  methods: {
    //列表
    handleList() {
      this.listLoading = true;
      this.tableData = [];
      handleListApi(this.listQuery)
        .then((response) => {
          const data = response.data.data;
          this.total = response.data.total;
          for (let item of response.data.data) {
            item.answer = item.answer.replace(/<[^>]+>/g, '');
            item.answer = item.answer.replace(/&nbsp;/gi, '');
            item.problem = item.problem.replace(/<[^>]+>/g, '');
            item.problem = item.problem.replace(/&nbsp;/gi, '');
            this.tableData.push(item);
          }
          this.tableData = data;
          let m = this.tableData[0].answer.replace(/<[^>]+>/g, '');
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    //获取选择列表
    handleGetSelect() {
      handleGetSelectApi()
        .then((response) => {
          this.typeData = response.data.type;
          this.gameData = response.data.game;
        })
        .catch((error) => {});
    },
    //添加
    handleCreate() {
      this.popupTitle = '添加';
      this.handleResetForm();
      if (this.addCheck == 1) {
        this.formData = JSON.parse(JSON.stringify(this.addData));
      }
      this.dialogFormVisible = true;
    },
    //修改
    handleUpdate(row) {
      this.resetRichTextUploads();
      this.popupTitle = '修改';
      this.dialogFormVisible = true;
      this.formData.id = row.id;
      getSingleFaqApi({ id: row.id })
        .then((response) => {
          const data = response.data.data;
          this.formData.game_id = data.game_id;
          this.formData.type_id = data.type_id;
          this.formData.answer = data.answer;
          this.formData.problem = data.problem;
          this.formData.admin_name = data.admin_name;
        })
        .catch((error) => {});
    },
    //查看
    handleDetail(row) {
      this.resetRichTextUploads();
      this.popupTitle = '查看';
      this.dialogFormVisible = true;
      this.formData.id = row.id;
      this.detail = 1;
      getSingleFaqApi({ id: row.id })
        .then((response) => {
          const data = response.data.data;
          this.formData.game_id = row.game_name;
          this.formData.type_id = row.type_name;
          this.formData.answer = data.answer;
          this.formData.problem = data.problem;
          this.formData.admin_name = data.admin_name;
        })
        .catch((error) => {});
    },
    //删除
    handleDelete(row) {
      handleDeleteApi(row)
        .then((response) => {
          this.$message.success('操作成功');
          row.deleteVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    //清空表单
    handleResetForm() {
      this.resetRichTextUploads();
      this.formData.id = '';
      this.formData.type_id = '';
      this.formData.game_id = [];
      this.formData.answer = '';
      this.formData.problem = '';
      this.dialogFormVisible = false;
      this.handleList(this.listQuery);
    },
    //清空表单x
    handleResetDetailForm() {
      if (this.popupTitle == '添加' && (this.addCheck == 0 || this.addCheck == 1)) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.popupTitle == '添加' && this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
      this.detail = 0;
      this.handleResetForm();
    },
    removeForm() {
      this.dialogFormVisible = false;
    },
    handleCreateUpdateStore() {
      if (!this.guardImageUploads(['faq-rich-text'])) return;
      if (this.formData.type_id == '') {
        alert('请选择类型！');
        return false;
      }
      if (this.formData.game_id == '') {
        alert('请选择游戏！');
        return false;
      }
      if (this.formData.problem == '') {
        alert('请填写问题！');
        return false;
      }
      handleCreateStoreApi(this.formData)
        .then((response) => {
          this.$message.success('操作成功');
          if (this.formData.id == '') {
            this.addCheck = 2;
          }
          this.dialogFormVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.handleList(this.listQuery);
    },
    //日志
    handleLogData(row) {
      this.gridData = [];
      handleLogDataApi({ id: row.id })
        .then((response) => {
          const data = response.data.data;
          for (let item of response.data.data) {
            item.content = item.content.replace(/<[^>]+>/g, '');
            item.content = item.content.replace(/&nbsp;/gi, '');
            this.gridData.push(item);
          }
          // this.gridData = data;
          this.dialogTableVisible = true;
        })
        .catch((error) => {});
    },
    //重置
    handleResetSearch() {
      if (this.listQuery.game_id != undefined) {
        this.listQuery.game_id = undefined;
      }
      if (this.listQuery.type_id != undefined) {
        this.listQuery.type_id = undefined;
      }
      if (this.listQuery.answer != undefined) {
        this.listQuery.answer = undefined;
      }
      if (this.listQuery.problem != undefined) {
        this.listQuery.problem = undefined;
      }
      if (this.listQuery.created_at != undefined) {
        this.listQuery.created_at = undefined;
      }
    },
    //富文本相关
    onEditorChange({ editor, html, text }) {
      //内容改变事件
      this.content = html;
    },
    openRichTextImagePicker(editorKey) {
      const state = this.getImageUploadScope('faq-rich-text');
      if (state.pending > 0) {
        this.$message.warning('图片正在上传，请稍后');
        return;
      }
      const editor = this.$refs[editorKey === 'question' ? 'questionEditor' : 'answerEditor'];
      if (!editor || !editor.quill) return;
      const selection = editor.quill.getSelection(true);
      this.richTextUploadContext = {
        batchId: ++this.richTextUploadBatch,
        editorKey,
        selectionIndex: selection ? selection.index : editor.quill.getLength(),
      };
      const upload = this.$refs.richTextUpload;
      const input = upload && upload.$el.querySelector('input[type="file"]');
      if (input) input.click();
    },
    // 富文本图片上传前
    beforeUpload() {
      this.quillUpdateImg = true;
      return true;
    },
    richTextUploadChange(file, fileList) {
      this.trackImageUpload('faq-rich-text', file, fileList);
      if (file.status === 'ready' && this.richTextUploadContext && !this.richTextUploadItems.some((item) => item.uid === file.uid)) {
        this.richTextUploadItems.push({
          uid: file.uid,
          name: file.name,
          file,
          batchId: this.richTextUploadContext.batchId,
          editorKey: this.richTextUploadContext.editorKey,
          selectionIndex: this.richTextUploadContext.selectionIndex,
          sequence: ++this.richTextUploadSequence,
          status: 'uploading',
          path: '',
          inserted: false,
        });
      }
      this.flushRichTextBatch(file && file.uid);
    },
    //富文本上传
    uploadSuccess(res, file, fileList) {
      if (!this.isCurrentImageUpload('faq-rich-text', file)) return;
      const item = this.richTextUploadItems.find((uploadItem) => uploadItem.uid === file.uid);
      if (!item) return;
      if (res.code == 200) {
        item.status = 'success';
        item.path = res.path;
      } else {
        file.status = 'fail';
        item.status = 'failed';
        this.$message.error('图片插入失败');
      }
      this.trackImageUpload('faq-rich-text', file, fileList);
      this.flushRichTextBatch(file.uid);
    },
    // 富文本图片上传失败
    uploadError(error, file, fileList) {
      if (!this.isCurrentImageUpload('faq-rich-text', file)) return;
      const item = this.richTextUploadItems.find((uploadItem) => uploadItem.uid === file.uid);
      if (item) item.status = 'failed';
      this.trackImageUpload('faq-rich-text', file, fileList);
      this.flushRichTextBatch(file && file.uid);
      this.$message.error('图片插入失败');
    },
    flushRichTextBatch(fileUid) {
      const current = this.richTextUploadItems.find((item) => item.uid === fileUid);
      if (!current) return;
      const batch = this.richTextUploadItems.filter((item) => item.batchId === current.batchId);
      if (!batch.length || batch.some((item) => item.status === 'uploading')) return;
      const editor = this.$refs[current.editorKey === 'question' ? 'questionEditor' : 'answerEditor'];
      if (!editor || !editor.quill) return;
      let offset = 0;
      batch
        .filter((item) => item.status === 'success' && !item.inserted)
        .sort((left, right) => left.sequence - right.sequence)
        .forEach((item) => {
          editor.quill.insertEmbed(item.selectionIndex + offset, 'image', item.path);
          item.inserted = true;
          offset += 1;
        });
      if (offset > 0) editor.quill.setSelection(current.selectionIndex + offset);
      this.quillUpdateImg = this.getImageUploadScope('faq-rich-text').pending > 0;
    },
    removeRichTextFailure(item) {
      const upload = this.$refs.richTextUpload;
      if (!item.file) return;
      const uploadFile = upload && upload.uploadFiles.find((file) => file.uid === item.file.uid);
      if (uploadFile) {
        upload.handleRemove(uploadFile);
      } else {
        this.richTextUploadRemove(item.file, (upload && upload.uploadFiles) || []);
      }
    },
    richTextUploadRemove(file, fileList) {
      this.richTextUploadItems = this.richTextUploadItems.filter((item) => item.uid !== file.uid);
      this.removeTrackedImage('faq-rich-text', file, fileList);
    },
    resetRichTextUploads() {
      this.resetImageUploadScope('faq-rich-text');
      if (this.$refs.richTextUpload) {
        this.$refs.richTextUpload.abort();
        this.$refs.richTextUpload.clearFiles();
      }
      this.richTextUploadContext = null;
      this.richTextUploadItems = [];
      this.quillUpdateImg = false;
    },
    //导入Excel
    importFaq(res, file) {
      if (res.code != 1) {
        this.$message.error(res.message);
        // 如果code是2 说明是部分成功 那就下载错误文件
        if (2 == res.code) {
          // window.open('http://worksn.hzwxbz2.cn/api/v1/admin/downloadErrorLog');
          window.open(BASE_API + 'admin/downloadErrorLog');
          this.handleList(this.listQuery);
        }
        return false;
      } else {
        this.$message.success(res.message);
      }
      this.handleList(this.listQuery);
    },
  },
};
</script>
<style >
div.el-transfer .el-transfer-panel {
  width: 400px;
}
.ql-editor.ql-blank,
.ql-editor {
  height: 350px;
}
.el-upload--text {
  width: 80px;
  height: 35px;
  border: none;
  margin-top: 10px;
}
.filter-item-upload {
  display: inline-block;
  margin: 0px 0px 0px 10px;
  transform: translateY(14px);
}
.download {
  margin-left: 10px;
}
.rich-text-upload-errors {
  margin-bottom: 10px;
  color: #f56c6c;
}
.rich-text-upload-errors .el-tag {
  margin-right: 8px;
}
</style>
